import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

interface RootCanvasModeSelectorProps {
  mode: 'root' | 'reference';
  hasAvailableRootFields: boolean;
  isSubmitting: boolean;
  onModeChange: (mode: 'root' | 'reference') => void;
}

export const RootCanvasModeSelector = ({
  mode,
  hasAvailableRootFields,
  isSubmitting,
  onModeChange,
}: RootCanvasModeSelectorProps) => {
  return (
    <>
      <FormControl component="fieldset">
        <RadioGroup
          value={mode}
          onChange={(e) => onModeChange(e.target.value as 'root' | 'reference')}
          aria-label="Root canvas configuration mode"
        >
          <FormControlLabel value="root" control={<Radio />} label="Create new canvas" disabled={isSubmitting} />
          <FormControlLabel
            value="reference"
            control={<Radio />}
            label={
              hasAvailableRootFields
                ? `Reference existing canvas (${hasAvailableRootFields ? 'available' : 'none available'})`
                : 'Reference existing canvas (create one first)'
            }
            disabled={isSubmitting || !hasAvailableRootFields}
          />
        </RadioGroup>
      </FormControl>

      {!hasAvailableRootFields && mode === 'reference' && (
        <Box sx={{ p: 2, bgcolor: 'info.lighter', borderRadius: 1 }}>
          <Typography variant="body2" color="info.main">
            💡 No canvas fields found in this process module. Create a canvas field first, then you'll be able to
            reference it from other fields.
          </Typography>
        </Box>
      )}
    </>
  );
};
